import Menu from "../components/menu";
import Flickity from "flickity";
import Table from "../util/table";
import Overlay from "../util/overlay";
import Header from "../components/header";
import Layout from "../components/layout";
import fadeInItemLoad from "../util/fadeInItem";
import Moveit from "../util/moveit";
import Selectblock from "../components/selectblock";
import CalendarReminder from "../components/calendar-reminder";
import throttle from "lodash.throttle";
import UTM from "../util/utm-tracking";

require("flickity/dist/flickity.css");
require("modernizr");

window.password_meets_min_reqs = function (value) {
    if (value.length < 6) {
        return false;
    }

    var reqs = /^.*(?=.{6,40})(?=.*\d)(?=.*[a-zA-Z]).*$/;

    if (value.match(reqs) != null) {
        return true;
    }

    return false;
};

window.checkPasswordStrength = function (
    $pass1,
    $strengthResult,
    blacklistArray,
    buttonToDisable,
    showHint
) {
    // console.log('checkPasswordStrength');

    var pass1 = $pass1.val();
    var pass2 = null;

    // Reset the form & meter
    // $submitButton.attr( 'disabled', 'disabled' );
    $strengthResult.removeClass("short bad good strong");

    // Extend our blacklist array with those from the inputs & site data
    blacklistArray = blacklistArray.concat(
        wp.passwordStrength.userInputDisallowedList()
    );

    // Get the password strength
    window.new_password_strength = wp.passwordStrength.meter(
        pass1,
        blacklistArray,
        pass2
    );

    // Add the strength meter results
    switch (window.new_password_strength) {
        case 2:
            $strengthResult.addClass("bad").html(pwsL10n.bad);
            break;

        case 3:
            $strengthResult.addClass("good").html(pwsL10n.good);
            break;

        case 4:
            $strengthResult.addClass("strong").html(pwsL10n.strong);
            break;

        case 5:
            $strengthResult.addClass("short").html(pwsL10n.mismatch);
            break;

        default:
            $strengthResult.addClass("short").html(pwsL10n.short);
    }

    if (
        window.password_meets_min_reqs(pass1) ||
        window.new_password_strength > 2
    ) {
        if (buttonToDisable) {
            // console.log('REENABLE BUTTON');
            buttonToDisable.prop("disabled", false);
        }
        if (showHint && jQuery("#password_hint").length) {
            // console.log('REMOVE PASSWORD HINT');
            jQuery("#password_hint").remove();
        }
        $pass1.parent("p").removeClass("woocommerce-invalid");
    } else {
        if (buttonToDisable) {
            // console.log('DISABLE BUTTON');
            buttonToDisable.prop("disabled", true);
        }
        if (showHint && !jQuery("#password_hint").length) {
            // console.log('ADD PASSWORD HINT');
            $strengthResult.after(
                '<span id="password_hint" class="input-error-message">Please enter a stronger password (6 characters minimum, including letters and numbers)</span>'
            );
        }
        $pass1.parent("p").addClass("woocommerce-invalid");
    }

    return;
};

function label_init() {
    "use strict";

    jQuery(".gform_body input, .gform_body textarea").on("focus", function () {
        var label = jQuery(this).parent().prev("label");
        jQuery(label).addClass("is-focus");
    });

    jQuery(".gform_body input, .gform_body textarea").on("blur", function () {
        var label = jQuery(this).parent().prev("label");
        if (jQuery(this).val() === "") {
            jQuery(label).removeClass("is-focus");
        }
    });
}

window.isElementInViewport = function (el) {
    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <=
            (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

function checkCtaStyles() {
    var hide_cta = false,
        hide_cta_buttons = document.querySelectorAll(".hide-cta"),
        cta_button = document.querySelector(".footer .cta");

    if (hide_cta_buttons !== null) {
        for (var i = 0; i < hide_cta_buttons.length; i++) {
            if (isElementInViewport(hide_cta_buttons[i])) {
                if (!cta_button.classList.contains("fadeOut")) {
                    cta_button.classList.remove("fadeIn");
                    cta_button.classList.add("fadeOut");
                }
                hide_cta = true;
            }
        }

        if (!hide_cta) {
            if (
                !cta_button.classList.contains("fadeIn") ||
                cta_button.classList.contains("hide")
            ) {
                cta_button.classList.remove("fadeOut");
                cta_button.classList.remove("hide");
                cta_button.classList.add("fadeIn");
            }
        }
    }
}

export default {
    init() {
        // console.log(
        //     "==================================================================="
        // );
        // console.log(
        //     "Website designed and built by Giant Peach https://giantpeach.agency"
        // );
        // console.log(
        //     "==================================================================="
        // );

        var detectie = require("detectie"),
            header = new Header(),
            footer = "",
            menu = new Menu(),
            newsletter_signup = "",
            selectblock = new Selectblock();

        if (detectie() !== false) {
            document.documentElement.classList.add("ie");
            if (detectie() <= 11) {
                document.documentElement.classList.add("ie-lteq-11");
            }
        } else {
            document.documentElement.classList.add("no-ie");
        }

        function callback() {
            this.classList.add("is-visible");
        }
        new CalendarReminder();

        var utm = new UTM();
        utm.storeData();
    },
    finalize() {
        var banner,
            testimonials,
            table = new Table(),
            overlays = document.querySelectorAll(".overlay"),
            overlay_id,
            overlay,
            layout = new Layout(),
            fadeInItem = new fadeInItemLoad(),
            moveit = new Moveit(),
            hide_cta_buttons,
            cta_button = document.querySelector(".cta");

        if (document.querySelector(".banner.js .banner__container") !== null) {
            banner = new Flickity(".banner.js .banner__container", {
                cellAlign: "left",
                wrapAround: true,
                autoPlay: 4000,
                selectedAttraction: 0.1,
                friction: 1,
            });
        }

        jQuery(window).on("load", function () {
            if (document.querySelector(".testimonials.js") !== null) {
                banner = new Flickity(".testimonials.js", {
                    cellAlign: "left",
                    wrapAround: true,
                    autoPlay: 5000,
                    selectedAttraction: 0.1,
                    friction: 1.6,
                    prevNextButtons: false,
                    pageDots: true,
                });
            }
        });

        if (overlays !== null) {
            for (var i = 0; i < overlays.length; i++) {
                overlay_id = overlays[i].id;
                overlay = new Overlay({
                    trigger: document.querySelectorAll(
                        ".overlay__button--" + overlay_id
                    ),
                });
            }
        }

        label_init();
        window.label_init = label_init;

        hide_cta_buttons = document.querySelectorAll(".hide-cta");

        if (cta_button !== null && hide_cta_buttons.length > 0) {
            window.addEventListener("load", checkCtaStyles);
            window.addEventListener("scroll", throttle(checkCtaStyles, 10));
            window.addEventListener("resize", throttle(checkCtaStyles, 10));
        } else if (cta_button !== null) {
            cta_button.classList.remove("hide");
        }

        document.addEventListener("update-overlays", function () {
            var overlays = document.querySelectorAll(".overlay");
            
            if (overlays !== null) {
                for (var i = 0; i < overlays.length; i++) {
                    overlay_id = overlays[i].id;
                    overlay = new Overlay({
                        trigger: document.querySelectorAll(
                            ".overlay__button--" + overlay_id
                        ),
                    });
                }
            }
        });

        jQuery(window).on("load", function () {
            if (document.querySelector(".products-testimonials-carousel") !== null) {
                banner = new Flickity(".products-testimonials-carousel", {
                    cellAlign: 'left',
                    contain: true,
                    wrapAround: false,
                    arrowShape: "M76.52,102.72c.98,1.01,2.6,1.04,3.61,.05,1.01-.98,1.04-2.6,.05-3.61L39.42,57.14,80.19,15.12c.98-1.01,.96-2.63-.05-3.61-1.01-.98-2.63-.96-3.61,.05L34.05,55.34c-.36,.36-.59,.81-.69,1.28-.09,.44-.07,.9,.07,1.33,.12,.37,.33,.71,.62,1l42.48,43.77Z",
                    autoPlay: false,
                    pageDots: false,
                    prevNextButtons: true,
                });
            }
        });     
        
        const product_faq_accordions = jQuery('.product-faq-accordion');
        if ( product_faq_accordions.length ) {
            for ( const el of product_faq_accordions ) {
                const product_faq_accordion = jQuery(el);
                const product_faq_accordion_heading = product_faq_accordion.find('.heading');
                const product_faq_accordion_content = product_faq_accordion.find('.content');

                product_faq_accordion_heading.on('click', function(){
                    product_faq_accordion_heading.toggleClass('active');
                    product_faq_accordion_content.stop(false, false).slideToggle();
                });
            }
        }

        jQuery('body').on('click', '.smooth-scroll', function(e) {
            e.preventDefault();

            const href = jQuery(this).attr('href');
            jQuery('html, body').animate({
                scrollTop: jQuery(href).offset().top
            }, 300);
        });        
    },
};



// WEBPACK FOOTER //
// ./js/routes/common.js